const $ = jQuery.noConflict();
import '@fancyapps/fancybox';
import 'flatpickr';

'use strict';
const TimeSheet = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBody: $('body'),
	$domHolderPopup: $('.js-cf7-holder-timesheet .cf7-holder__popup'),
	$domHolderPopupWrapper: $('.js-cf7-holder-timesheet .cf7-holder__popup-wrapper'),

	classDisabledButton: 'button-disabled',
	classFormIsSent: 'form-is-sent',
	classPreventScroll: 'prevent-scroll',
	classChecked: 'checked',

	/** @description Initialize */
	init: function() {
		this.appendElements();
		this.events();
		this.preventCharacterInput();
		this.widthChanges();
		this.preventFormFieldReset();
		this.preventFormSubmitIfSignatureEmpty();
		this.triggerClosePopup();
		this.handleFormSubmit();
		this.initFlatpickr();
	},

	initFlatpickr: () => {
		const flatpickrOptions = {
			enableTime: true,
			noCalendar: true,
			dateFormat: 'G:i'
		};
		$('#start-time').flatpickr(flatpickrOptions);
		$('#end-time').flatpickr(flatpickrOptions);

		$('.flatpickr-calendar:first').on('click', function() {
			const ampm = $(this).find('.flatpickr-am-pm').text();
			$('.start-time-mark').text(ampm);
		});

		$('.flatpickr-calendar:last').on('click', function() {
			const ampm = $(this).find('.flatpickr-am-pm').text();
			$('.end-time-mark').text(ampm);
		});
		const startTimeFormat = $('input[name="start-time-format"]');
		const endTimeFormat = $('input[name="end-time-format"]');
		startTimeFormat.attr('value', 'PM');
		endTimeFormat.attr('value', 'PM');
		$('.flatpickr-calendar.hasTime:first').on('click', function() {
			const amPmStart = $(this).find('.flatpickr-am-pm').text();
			startTimeFormat.attr('value', amPmStart);
		});
		$('.flatpickr-calendar.hasTime').eq(1).on('click', function() {
			const amPmEnd = $(this).find('.flatpickr-am-pm').text();
			endTimeFormat.attr('value', amPmEnd);
		});
	},

	closePopup: (element) => {
		element.on('click', function() {
			TimeSheet.$domHolderPopup.removeClass(TimeSheet.classFormIsSent);
			TimeSheet.$domBody.removeClass(TimeSheet.classPreventScroll);
		});
	},

	closePopupOnOutsideClick: () => {
		$(document).on('click', function(event) {
			const $popup = TimeSheet.$domHolderPopup;
			const $popupWrapper = TimeSheet.$domHolderPopupWrapper;

			if ($popup.length && $popupWrapper.length && !$popupWrapper.is(event.target) && $popupWrapper.has(event.target).length === 0 && !$('.temp-link').is(event.target) && $('.temp-link').has(event.target).length === 0) {
				TimeSheet.$domHolderPopup.removeClass(TimeSheet.classFormIsSent);
				TimeSheet.$domBody.removeClass(TimeSheet.classPreventScroll);
			}
		});
	},

	triggerClosePopup: () => {
		TimeSheet.closePopup($('.js-cf7-holder__popup-close'));
		TimeSheet.closePopupOnOutsideClick();
	},

	preventFormSubmitIfSignatureEmpty: () => {
		const signatureInput = $('#signature');
		if (signatureInput.length > 0) {
			const buttonWrapper = $('.js-cf7-holder-timesheet .contact-form__input-button-wrapper');
			buttonWrapper.addClass(TimeSheet.classDisabledButton);

			$(document).on('click mouseup mousedown mousemove touchstart touchend touchmove', function() {
				if (signatureInput.attr('value') === '') {
					buttonWrapper.addClass(TimeSheet.classDisabledButton);
				} else {
					buttonWrapper.removeClass(TimeSheet.classDisabledButton);
				}
			});
		}
	},

	handleFormSubmit: () => {
		$(document).on('wpcf7mailsent', '.js-cf7-holder-timesheet form', function() {
			TimeSheet.$domHolderPopup.addClass(TimeSheet.classFormIsSent);
			TimeSheet.$domBody.addClass(TimeSheet.classPreventScroll);
		});
	},

	preventFormFieldReset: () => {
		$(document).on('reset', '.js-cf7-holder-timesheet form', function(e) {
			e.preventDefault();
		});
	},

	widthChanges: () => {
		const signatureBox = $('#digital_signature-pad_signature');

		if ($(window).width() < 992) {
			signatureBox.attr('width', 334);
			signatureBox.attr('backcolor', '#fff');
		}
	},

	appendElements: () => {
		$('.js-time-sheet__select-program').insertAfter('.js-time-sheet-program label');
		$('.js-time-sheet .select2-container').insertAfter('.js-time-sheet__select-program');
		$('.js-time-sheet .wpcf7-list-item').each(function() {
			$(this).find('.wpcf7-list-item-label').after('<span class="checkmark"></span>');
		});
	},

	events: () => {
		const selectProgram = $('.js-time-sheet__select-program');
		const selectProgramInput = $('.js-time-sheet-program-input');

		selectProgram.on('change', function() {
			const data = $(this).val();
			selectProgramInput.val(data);
			$('#date-of-service').trigger('click');
		});

		const radio = $('.wpcf7-list-item input[type="radio"]');
		const radioItems = $('.wpcf7-list-item');

		$('.wpcf7-list-item:first').addClass(TimeSheet.classChecked);
		radio.on('change', function() {
			radioItems.removeClass(TimeSheet.classChecked);
			$(this).closest('.wpcf7-list-item').addClass(TimeSheet.classChecked);
		});
	},

	preventCharacterInput: () => {
		/* const medicaidNumber = $('#individual-medicaid-number');
		medicaidNumber.on('keypress', TimeSheet.allowOnlyNumbers); */
	},

	allowOnlyNumbers(event) {
		const charCode = event.which ? event.which : event.keyCode;

		if (charCode === 8 || charCode === 9 || charCode === 13 || charCode === 46 || (charCode >= 37 && charCode <= 40)) {
			return true;
		}

		if (charCode >= 48 && charCode <= 57) {
			return true;
		}

		event.preventDefault();
		return false;
	}
};

export default TimeSheet;
